export function getTariffByTypeAndID(axiosPrivate, type, idTariff) {
  return axiosPrivate.get(`/tariff/${type}/${idTariff}`)
}

export function updateTariffByTypeAndID(axiosPrivate, type, formData) {
  const idTariff = formData.id
  return axiosPrivate.put(`/tariff/${type}/${idTariff}`, formData)
}

export function createTariffByType(axiosPrivate, type, formData) {
  return axiosPrivate.post(`/tariff/${type}`, formData)
}

export function getHSVersionsFromHSDescription(axiosPrivate) {
  return axiosPrivate.get(`/tariff/hs-versions`)
}

export function getHSCodesFromHSDescriptions(axiosPrivate, params) {
  return axiosPrivate.get(`/tariff/hs-codes`, { params })
}

export function getHSDetail(axiosPrivate, hs, version) {
  return axiosPrivate.get(`/tariff/hs-code/${hs}/${version}`)
}

export function getPrefTariffCodes(axiosPrivate, params) {
  return axiosPrivate.get(`/tariff/pref-codes`, { params })
}

export function getPrefTariffSources(axiosPrivate, params) {
  return axiosPrivate.get(`/tariff/pref-sources`, { params })
}
